<template>
  <BaseDropDownMenu
    :title="$t('global.action')"
    size="small"
    :options="options"
  />
</template>

<script>
export default {
  name: 'WorkAttachmentsDropDown',
  props: {
    attachmentIndex: { type: Number, required: true }
  },
  emits: ['changeEditMode', 'showFile', 'printFile', 'deleteFile'],
  computed: {
    options() {
      return [
        [
          {
            label: this.$t('button.rename'),
            icon: 'edit',
            gate: true,
            action: () => this.$emit('changeEditMode')
          },
          {
            label: this.$t('button.show'),
            icon: 'eye',
            gate: true,
            action: () => this.$emit('showFile')
          },
          {
            label: this.$t('button.print'),
            icon: 'print',
            gate: true,
            action: () => this.$emit('printFile')
          }
        ],
        [
          {
            label: this.$t('button.delete'),
            icon: 'times',
            gate: true,
            txt_color: 'text-red-600',
            action: () => this.$emit('deleteFile')
          }
        ]
      ]
    }
  }
}
</script>
